import Interface from '../../interface/input'

export default ({ value }: Interface) => value
